import { Icon, Stack, Card } from '@openedx/paragon';

import type { SidebarDetailsItemProps } from './types';

const SidebarDetailsItem = ({ icon, label, value }: SidebarDetailsItemProps) => (
  <>
    <Stack className="course-about-sidebar__detail p-2" direction="horizontal" gap={2}>
      <Stack className="course-about-sidebar__detail-label" direction="horizontal" gap={2}>
        <Icon src={icon} />
        <span data-testid="sidebar-details-item-label">
          {label}
          :
        </span>
      </Stack>
      <span className="course-about-sidebar__detail-value" data-testid="sidebar-details-item-value">{value}</span>
    </Stack>
    <Card.Divider />
  </>
);

export default SidebarDetailsItem;
